import { Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbAccordionDirective } from '@ng-bootstrap/ng-bootstrap';
import { SofttokenInputModel } from '../models/softtokeninput.model';
import { Subscription } from 'rxjs';
import { LibConfig, LibConfigService } from '../libconfig.service';

@Component({
  standalone: false,
  selector: 'app-soft-token',
  templateUrl: './soft-token.component.html',
  styleUrls: ['./soft-token.component.scss']
})
export class SoftTokenComponent implements OnInit, OnDestroy {

  subscriptions: Subscription = new Subscription;
  
  mainForm!: FormGroup;
  secretPushCode!: string;
  interval!: number;

  hasAutoEnrolled = false;
  isSaving = false;
  isModalHidden: boolean = true;

  @Input() options!: SofttokenInputModel;

  chosenAuthenticatorType: string = 'securenvoy';
  isThirdParty: boolean = false;
  gettingQr = false;

  @Output() output: EventEmitter<SoftTokenOutput> = new EventEmitter<SoftTokenOutput>();

  isSecondFactor!: string;

  enrolUrl!: string;


  @ViewChild('acc') accordion!: NgbAccordionDirective;

  constructor(
    @Inject(LibConfigService) private config: LibConfig
  ) { }

    ngOnDestroy(): void {
      window.clearInterval(this.interval);
      this.subscriptions.unsubscribe();
    }

  ngOnInit(): void {
    this.createForm();
    if (this.options.state.pushEnforced && this.options.state.pushAllowed) {
      this.mainForm.controls['pushEnabled'].disable();
      this.options.state.authenticatorType = 'securenvoy';
    } else if (!this.options.state.pushAllowed) {
      this.options.state.pushEnabled = false;
      this.mainForm.controls['pushEnabled'].disable();
      this.mainForm.controls['pushEnabled'].setValue(false);
    }

    
    if (this.options.state.authenticatorType != 'thirdparty') {
      this.startCheckAutoEnrolTimer();
    }

    if (this.options.state.authenticatorType != 'both') {
      this.chosenAuthenticatorType = this.options.state.authenticatorType;
      this.isThirdParty = this.chosenAuthenticatorType == 'thirdparty';
    }
    this.getUserSeedCode();
  }

  createForm() {
    this.mainForm = new FormGroup({
      checkCode: new FormControl({ value: null, disabled: this.hasAutoEnrolled }, [Validators.maxLength(8)]),
      pushEnabled: new FormControl({ value: this.options.state.pushEnabled, disabled: this.options.state.pushEnforced },),
      authenticatorType: new FormControl({ value: this.chosenAuthenticatorType, disabled: this.options.state.authenticatorType != 'both'})
    });
    this.mainForm.controls['checkCode'].valueChanges.subscribe(x => {
      let output: SoftTokenOutput = {
        hasAutoEnrolled: false,
        enrolUrl: this.enrolUrl,
        checkCode: x,
        pushEnabled: this.options.state.pushEnabled
      };
      this.output.emit(output);
    })
    this.mainForm.controls['authenticatorType'].valueChanges.subscribe(x => {
      this.chosenAuthenticatorType = x;
      this.isThirdParty = this.chosenAuthenticatorType == 'thirdparty';
      this.getUserSeedCode();
      window.clearInterval(this.interval);
      if (this.chosenAuthenticatorType == 'securenvoy') {
        this.startCheckAutoEnrolTimer();
      }
    })
  }


  startCheckAutoEnrolTimer() {
    this.interval = window.setInterval(() => {
      this.checkAutoEnrol();
    }, this.config.pushCheckTime * 1000);
  }

  checkAutoEnrol() {
    this.subscriptions.add(
    this.options.functions.userEnrolReadyStatus(!this.options.state.pushEnabled).subscribe(
      (data: any) => {
        if (data === true) {
          window.clearInterval(this.interval);
          this.hasAutoEnrolled = true;
          this.mainForm.controls['checkCode'].disable();
          this.enrolUrl = '';
          this.accordion?.collapseAll();
          this.closeQrImage();
          const element = document.getElementById('target');
          if (element) {
            this.scroll(element);
          }
          var overlay = document.getElementById('overlay');
          if(overlay) { overlay.style.display = 'block'; }
          let output: SoftTokenOutput = {
            enrolUrl: this.enrolUrl,
            hasAutoEnrolled: true,
            pushEnabled: this.options.state.pushEnabled
          };
          this.output.emit(output);
        }
      }));
  }

  scroll(el: HTMLElement) {
    el.scrollIntoView();
  }

  removeOverlay() {
    let overlay = document.getElementById('overlay')
    if(overlay) { overlay.style.display = 'none'; }
  }

  getUserSeedCode() {
    this.gettingQr = true;
    this.subscriptions.add(
      this.options.functions.userSeedUrl(!this.options.state.pushEnabled, this.options.state.authenticatorType == 'thirdparty').subscribe(
      (data: any) => {
        this.enrolUrl = data.link;
        const response1 = this.enrolUrl.split('?');
        const response2 = response1[1].split('&');
        const response3 = response2[0].split('=');
        this.secretPushCode = response3[1];
        const regAddSpaceCharacterInput = this.secretPushCode.length > 13 ? this.options.validators.regAddSpaceCharacterInputThirdParty : this.options.validators.regAddSpaceCharacterInput
        this.secretPushCode = this.secretPushCode.replace(regAddSpaceCharacterInput, this.options.validators.regAddSpaceCharacterOutput);
        this.gettingQr = false;
      }));
  }

  enlargeImage() {
    if (!this.gettingQr) {
      this.isModalHidden = false;
    }
  }

  closeQrImage() {
    this.isModalHidden = true;
  }

  changePushEnabled() {
    this.options.state.pushEnabled = !this.options.state.pushEnabled;
    this.getUserSeedCode();
  }

}

export interface SoftTokenOutput {
  hasAutoEnrolled: boolean,
  checkCode?: string,
  enrolUrl?: string,
  pushEnabled: boolean
}
